let scheduler = {
  title: 'Agenda',
  title_s: 'Agendamento',
  icon: 'mdi-calendar-clock',
  now: 'AGORA',
  next: 'Agendamentos Próximos',
  recent: 'Agendamentos Recentes',
  view: {
    history: {
      created: 'Criado',
      edited: 'Editado',
      deleted: 'Excluido'
    }
  },
  dialog: {
    deleteConfirm: 'Tem certeza que deseja excluir o Agendamento',
    cancelConfirm: 'Tem certeza que deseja cancelar o Agendamento'
  },
  new: {
    title: 'Novo Agendamento',
    close: 'Fechar',
    sch_title: 'Título (Resumido)',
    duration: 'Duração (min)',
    limit: 'Ag. por Horário',
    date: 'Data',
    time: 'Horário',
    employee: 'Profissional',
    widget: {
      title: 'Procurar Agendamento',
      infotip: 'Múltiplos Profissionais são permitidos apenas<br/>para serviços compartilhados, não recomendado<br/>para agendamentos com serviços separados.<br/><br/>Campos em Branco buscará todos os resultados<br/>na ordem recomendada.',
      filters: {
        employees: {
          title: 'Profissionais',
          noEmployees: 'Nenhum Profissional encontrado',
          groups: {
            recommended: 'Recomendados',
            assistants: 'Assistencia',
            others: 'Outros'
          }
        },
        match: {
          title: 'Apenas Combinações',
          infotip: 'Se Ativo, buscará somente horários dos<br/>quais todos Profissionais selecionados<br/>estejam disponíveis.'
        },
        office_hour: {
          title: 'Apenas Expediente',
          infotip: 'Se Selecionado, irá ignorar janelas<br/>fora do horário do expediente.'
        },
        date: 'Data',
        time: 'Horário'
      },
      selector: {
        available: {
          title: 'Disponíveis',
          no_results: 'Nenhum Horário disponível para os filtros selecionados.'
        },
        selected: {
          title: 'Selecionados',
          no_selected: 'Favor selecionar algum horário disponível.',
          no_employees: 'Favor selecionar os Profissionais'
        }
      },
    },
    rules: {
      title: [
        v => !!v || 'Título é obrigatório',
        v => (v && v.length <= 27) || 'O Título deve ter menos que 27 caracteres'
      ],
      duration: [
        v => ( v && v >= 5 ) || "Deve ser maior que 5"
      ],
      employee: [
        v => !!v || 'Profissional é obrigatório'
      ]
    }
  },
  edit: {
    title: 'Editar Agendamento',
    title_: (id) => `Editar Agendamento #${id}`
  },
  datatable: {
    search: 'Pesquisar',
    no_data: 'Sem Agendamentos',
    no_results: 'Nenhum resultado encontrado',
    items_per_page: 'Agendamentos por página',
    headers: {
      id: 'ID',
      created: 'Criação',
      employees: 'Profissionais',
      customer: 'Cliente',
      service: 'Serviço',
      title: 'Título',
      scheduling: 'Agendamento',
      start: 'Início',
      end: 'Fim',
      status: 'Status',
      action: 'Ações',
      history: 'Histórico'
    }
  },
  status: {
    waiting: 'Aguardando',
    completed: 'Concluido',
    adjourned: 'Adiado',
    canceled: 'Cancelado',
    deleted: 'Excluido'
  },
  actions: {
    title: 'Ações',
    view: 'Ver',
    hold: 'Adiar',
    cancel: 'Cancelar',
    edit: 'Editar',
    status: 'Mudar Status',
    save: 'Salvar',
    delete: 'Excluir'
  },
  calendar: {
    types: {
      month: 'Mês',
      week: 'Semana'
    }
  },
  messages: {
    error: {
      not_found: 'Agendamento não encontrado'
    }
  }
}

export default scheduler
